interface RecommendationMiniThumbProps {
  headUrl: string | null | undefined;
  displayName: string;
}

export function RecommendationMiniThumb({ headUrl, displayName }: RecommendationMiniThumbProps) {
  const initial = displayName.slice(0, 1) || '?';
  if (headUrl) {
    return (
      <img
        src={headUrl}
        alt=""
        className="reason-mini-thumb"
        width={24}
        height={24}
      />
    );
  }
  return (
    <span className="reason-mini-thumb reason-mini-thumb--placeholder" aria-hidden>
      {initial}
    </span>
  );
}
